// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2pOxq","label":"CategoryService_label__3hq6o","location":"CategoryService_location__2rKPG"};